import { useState } from "react";
import { categories, stories, type CategoryKey, type Story } from "@/mocks/stories";
import StoryCard from "./StoryCard";

const featuredIds = [3, 6, 2, 10, 4, 1];
const featuredPicks: Story[] = featuredIds
  .map((id) => stories.find((s) => s.id === id))
  .filter((s): s is Story => Boolean(s));

const chipLabels: { key: CategoryKey | "all"; name: string; emoji: string }[] = [
  { key: "all", name: "全部", emoji: "🌟" },
  ...categories.map((c) => ({ key: c.key as CategoryKey, name: c.name, emoji: c.emoji })),
];

export default function FeaturedSection() {
  const [active, setActive] = useState<CategoryKey | "all">("all");

  const list =
    active === "all"
      ? featuredPicks
      : stories.filter((s) => s.category === active).slice(0, 6);

  return (
    <section id="featured" className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-bold text-accent-900">
            <i className="ri-flashlight-fill" /> HOT 今日
          </span>
          <h2 className="mt-3 font-heading text-3xl text-foreground-900 md:text-4xl">
            今日爆点，笑着笑着就上头了
          </h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">
            挑几条最下饭的宿舍与课堂名场面，先笑为敬。
          </p>
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {chipLabels.map((c) => (
          <button
            key={c.key}
            onClick={() => setActive(c.key)}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
              active === c.key
                ? "bg-primary-500 text-white"
                : "border border-background-200 bg-background-50 text-foreground-600 hover:border-primary-200 hover:text-primary-700"
            }`}
          >
            <span>{c.emoji}</span>
            {c.name}
          </button>
        ))}
      </div>

      <div className="mt-7 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {list.map((s) => (
          <StoryCard key={s.id} story={s} />
        ))}
      </div>
    </section>
  );
}